module.exports = __webpack_public_path__ + "static/img/3-design-b4.afc5b7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3-design-b4.jpg
// module id = s+NX
// module chunks = 0